import { render, staticRenderFns } from "./AuthTeamEditComponent.vue?vue&type=template&id=d28334e0&scoped=true"
import script from "./AuthTeamEditComponent.vue?vue&type=script&lang=js"
export * from "./AuthTeamEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28334e0",
  null
  
)

export default component.exports